<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-left-circle`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M24 2c12.15 0 22 9.85 22 22s-9.85 22-22 22S2 36.15 2 24 11.85 2 24 2zm0 4C14.059 6 6 14.059 6 24s8.059 18 18 18 18-8.059 18-18S33.941 6 24 6zm2.293 9.293l1.414 1.414a1 1 0 010 1.414L21.828 24l5.88 5.879a1 1 0 010 1.414l-1.415 1.414a1 1 0 01-1.414 0l-8-8a1 1 0 010-1.414l8-8a1 1 0 011.414 0z"/></svg>
</template>
<script>

export default {
  name: 'IconLeftCircle',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
